import api from "../api/axios";

// 🔹 Applied reimbursements (employee's own)
export const getAllExpenses = async (id) => {
  const response = await api.get(`api/reimbursements/${id}`);
  return response.data;
};

// 🔹 First-level approvals
export const getApprovals = async (id) => {
  const response = await api.get(`api/reimbursementsForApproval/${id}`);
  return response.data.result || [];
};

// 🔹 Next-level approvals
export const getNextLevelApprovals = async (id) => {
  const response = await api.get(`api/reimbursement-for-approval/${id}`);
  return response.data.result || [];
};

// 🔹 Delete reimbursement
export const deleteExpense = async (id) => {
  return api.put(`api/reimbursement-delete/${id}`);
};

// 🔹 Create reimbursement
export const createExpense = async (formData) => {
  return api.post(`api/reimbursement`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// 🔹 Update reimbursement
export const updateExpense = async (id, formData) => {
  return api.put(`api/reimbursement-update/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// 🔹 Update approval status
export const updateReimbursementStatus = async (
  reimbursement_id,
  payload
) => {
  return api.post(
    `api/reimbursementsForApprova/${reimbursement_id}`,
    payload
  );
};
